/**
  This module abstracts storage solutions provided by browsers.

  It tries to use `localStorage` as the default storage engine but will fall back to
  no storage solution if `localStorage` is not supported.
  In case no storage solution is used, it will trigger a single warning to the browser
  console and silently ignore all further calls to write or read data from browser storage.

  The main reason for this component is that some browsers refuse access to `localStorage`,
  e.g. Safari in private mode.
 */
define([],
    function() {
        var DB_NAME = 'smileback',
            db;
        try {
            var x = 'test-localstorage-' + Date.now();
            localStorage.setItem(x, x);

            var y = localStorage.getItem(x);
            localStorage.removeItem(x);

            if (y !== x) {
                throw new Error();
            }
            db = localStorage;
        } catch (e) {
            console.log('Cannot find browser storage solution. Disabling this feature.');
            db = undefined;
        }

        function key(idx) {
            if (db) {
                return db.key(idx);
            }
        }

        return {
            setItem: function(key, value, nestedId) {
                if (db) {
                    if (nestedId) {
                        db.getItem(key); // get full object
                        let obj = JSON.parse(db.getItem(key)) || {}; // parse it or create new if not existing
                        obj[nestedId] = JSON.parse(value); // set nested value
                        value = JSON.stringify(obj); // stringify it again for storage
                    }

                    return db.setItem(key, value);
                }
            },
            getItem: function(key, nestedId) {
                if (db) {
                    if(nestedId) {
                        let obj = JSON.parse(db.getItem(key)); // get full object and parse it
                        return obj ? JSON.stringify(obj[nestedId]) : null; // return nested value or null if not existing
                    }

                    return db.getItem(key);
                }
            },
            removeItem: function(key, nestedId) {
                if (db) {
                    if(nestedId) {
                        let obj = JSON.parse(db.getItem(key)); // get full object and parse it
                        delete obj[nestedId]; // delete nested value
                        return db.setItem(key, JSON.stringify(obj)); // save updated object
                    }
                    
                    return db.removeItem(key);
                }
            },
            addObj: function(key,obj) {
                db.setItem(key , JSON.stringify(obj));
            },
            getObj: function(key) {
                 return JSON.parse( db.getItem(key) );
            },
            setOrRemoveItem: function(key, value) {
                if(value) {
                    this.setItem(key, value);
                } else {
                    this.removeItem(key);
                }
            },
            clearByPrefix: function(prefix) {
                var i = this.length;
                while (i--) {
                    if (key(i) && key(i).indexOf(prefix) > -1) {
                        this.removeItem(key(i));
                    }
                }
            },
            length: (db ? db.length : 0)
        };
    }
);
